import {classNames} from "shared/lib/classNames/classNames";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Paragraph, {ParagraphTheme} from "shared/ui/Paragraph/Paragraph";
import AppImg, {AppSize} from "shared/ui/AppImg/AppImg";
import {Carousel as InfinityCarousel} from "react-responsive-carousel";
import {ReactComponent as Arrow} from "shared/assets/icons/Arrow.svg";
import {ReactComponent as AppStore} from "shared/assets/icons/AppStoreDownload.svg";
import {ReactComponent as GooglePlay} from "shared/assets/icons/GooglePlayDownload.svg";
import {ReactComponent as GooglePlaySoon} from "shared/assets/icons/GooglePlaySoon.svg";
import {ReactComponent as AppStoreSoon} from "shared/assets/icons/AppStoreSoon.svg";
import HeroImage from "shared/ui/HeroImage/HeroImage";
import cls from "./AppDetails.module.scss";

interface AppDetailsProps {
    app: {
        id: string;
        img: string;
        title: string[];
        description: string;
        purpose?: string;
        creative: string[];
        links?: Partial<Record<any, string>>;
    }
    className?: string
}

export const AppDetails = ({app, className}: AppDetailsProps) => {
    return (
        <section className={cls.AppMain}>
            <div className={classNames(cls.AppDetails, {}, [className, "container__page"])}>
                <div className={cls.App__header}>
                    <Title
                        className={cls.App__title}
                        //padded
                        sentences={app.title}
                        colors={[TitleTheme.NEUTRAL, TitleTheme.PRIMARY]}
                    />

                    <div className={cls.App_description}>
                        <Paragraph theme={ParagraphTheme.BRIGHT}>
                            {app.description}
                        </Paragraph>
                    </div>

                    <div className={cls.App__imageBlock}>
                        <AppImg size={AppSize.M} href={app.id} imgSrc={app.img} className={cls.App__image}/>
                    </div>
                </div>
            </div>
            <div className={cls.Gallery}>
                <div className={cls.App__gallery}>
                    <InfinityCarousel
                        infiniteLoop={true}
                        showStatus={false}
                        showIndicators={false}
                        showThumbs={false}
                        showArrows={false}
                        //autoPlay
                        emulateTouch
                        renderArrowNext={(clickHandler, hasNext, label) => (
                            <div className={cls.Carousel__next}>
                                <Arrow onClick={clickHandler}/>
                            </div>
                        )}
                        renderArrowPrev={(clickHandler, hasNext, label) => (
                            <div className={cls.Carousel__prev}>
                                <Arrow onClick={clickHandler}/>
                            </div>
                        )}
                    >
                        {app.creative.map((creative) => {
                            return (
                                <div className={cls.Carousel__item}>
                                    <HeroImage img={creative}/>
                                </div>
                            )
                        })}
                    </InfinityCarousel>
                </div>
            </div>

            <div className={"container__page"}>
                <div className={cls.App__purpose}>
                    <h6>
                        Purpose of using the application
                    </h6>
                    <Paragraph className={"preWrap"} theme={ParagraphTheme.BRIGHT}>
                        {app.purpose}
                    </Paragraph>

                    {app.links ? (
                        <div className={cls.applicationStores}>
                            {app.links.APP_STORE && (
                                <div className={cls.applicationStores__item}>
                                    <a href={app.links.APP_STORE}>
                                        <AppStore/>
                                    </a>
                                </div>
                            )}

                            {app.links.GOOGLE_PLAY && (
                                <div className={cls.applicationStores__item}>
                                    <a href={app.links.GOOGLE_PLAY}>
                                        <GooglePlay/>
                                    </a>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={cls.applicationStores}>
                            <div>
                                <AppStoreSoon/>
                            </div>

                            <div>
                                <GooglePlaySoon/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
};

